import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';

/***
 * Класс формы вопросов
 * @example
 *
 * Классы:
 * question-form_interact - вешается после того, когда все инпуты в форме заполнены
 */
class QuestionForm {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент формы с классом question-form
   */
  constructor(elem) {
    this.BlockError = new BlockError({ blockName: 'QuestionForm', destroy: this.destroy });

    if (!elem) return this.BlockError.error('Отсутствует elem');
    this.block = elem;
    this.block.QuestionForm = this;
    this.block.AsyncQuestionForm = new Promise((resolve) => {
      this.promiseResolve = resolve;
    }).then((ins) => ins);

    this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'question-form_inited' });
    this.LazyInit.init();
  }

  init = () => {
    this.reset = this.block.querySelector('.question-form__reset');

    this.formData = new FormData(this.block);
    if (!this.formData) return this.BlockError.error('Данный блок не является формой');

    if (this.reset) {
      this.block.addEventListener('change', this.checkForm);
      this.block.addEventListener('reset', this.removeClass);
    }

    this.promiseResolve(this);
    this.block.AsyncQuestionForm = this;
  };

  checkForm = () => {
    let newFormData = new FormData(this.block);
    let isChanged = false;

    for (let [name, value] of newFormData) {
      if (value !== this.formData.get(name)) {
        isChanged = true;
        break;
      }
    }

    this.block.classList.toggle('question-form_interact', isChanged);
  };

  removeClass = () => this.block.classList.remove('question-form_interact');

  destroy = () => {
    if (this.LazyInit) this.LazyInit.destroy();
    if (this.block) {
      this.block.removeEventListener('change', this.checkForm);
      this.block.removeEventListener('reset', this.removeClass);
      this.block.classList.remove('question-form_inited');
      delete this.block.QuestionForm;
      delete this.block.AsyncQuestionForm;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('.question-form:not(.question-form_inited)')).forEach((elem) => new QuestionForm(elem));
  }
}

document.addEventListener('DOMContentLoaded', QuestionForm.init);

// Экспорт;
window.Block.QuestionForm = QuestionForm;
